module.exports = __webpack_public_path__ + "img/mp-solution-bg-3.67aecec3.jpg";